import * as React from 'react';
import { FormikProps } from 'formik';
import { useIntl } from 'react-intl';
import { CmdAlert } from '@commander-services/gui-components';
import FormikService from '../../../../Services/FormikService';
import useDocumentTitle from '../../../../hooks/useDocumentTitle';
import useAnalytics from '../../../../hooks/useAnalytics';

interface IModalFormProps extends FormikProps<any> {
  id: string;
  children: React.ReactNode;
  save: (values: any) => void;
  isButtonLoaderActive: boolean;
  alert: any;
  isDone: boolean;
}

export default function ModalForm(props: IModalFormProps): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();
  useDocumentTitle(f({ id: 'resetPassword.form.newPassword' }));

  const handleButtons = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();

    const errors = await props.validateForm();
    if (Object.keys(errors).length === 0) {
      props.save(props.values);
    } else {
      FormikService.setFieldsTouched(props.values, props.setTouched);
    }
  };

  return (
    <div className="w-login-content">
      {!props.isDone && <CmdAlert id="reset-password-alert" data={props.alert} />}
      <div className="b-login">
        <div className="headline">
          <h3 className="title">{f({ id: 'resetPassword.form.newPassword' })}</h3>
        </div>
        {!props.isDone ? (
          <form
            id={props.id}
            className="form-horizontal"
            onReset={() => {
              trackEvent(['Reset password', 'click', 'Reset form']);
              props.handleReset();
            }}
            onSubmit={() => {
              trackEvent(['Reset password', 'click', 'Submit form']);
              props.handleSubmit();
            }}
          >
            <div className="p-8">{props.children}</div>
            <div className="text-right">
              <div className="foot py-6 px-8">
                {props.isButtonLoaderActive ? (
                  <div className="e-button e-button--gray d-flex w-100">
                    <i className="cmd-icon-loader animation-spin" />
                  </div>
                ) : (
                  <button
                    type="submit"
                    id="submitNewPassword"
                    onClick={handleButtons}
                    className="e-button e-button--gray d-flex w-100"
                    data-cy="button_submit_new_password"
                    disabled={!props.isValid}
                  >
                    {f({ id: 'newPassword.confirm' })}
                  </button>
                )}
                <a href="/" title="" className="fs-3 mt-1 d-inline-block">
                  {f({ id: 'forgotPassword.login' })}
                </a>
              </div>
            </div>
          </form>
        ) : (
          <div>
            <div className="p-8">{f({ id: 'newPassword.done' })}</div>
            <div className="foot p-6">
              <a href="/" onClick={() => trackEvent(['login (verify)', 'click', 'Frogot password link'])} className="e-button e-button--gray d-flex w-100">
                {f({ id: 'forgotPassword.login' })}
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
